module.exports = __webpack_public_path__ + "static/img/3.6108771.png";


//////////////////
// WEBPACK FOOTER
// ./static/hz/3.png
// module id = zXBq
// module chunks = 202